import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Time } from '@shared/constants';
import { CurrentLanguageService } from '@shared/services/language/current-language.service';
import { PriceEstimator } from '@shared/services/price-estimator/models';
import { envConfiguredNetworkId } from '@shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PriceEstimatorService extends ApiServiceBase<unknown> {
  constructor() {
    super(
      `price_estimator/result?networkId=${envConfiguredNetworkId(inject(CurrentLanguageService).language.region)}`,
      'priceEstimator',
      'fournierWebservice'
    );
  }

  fetchEstimatedPrices(ids: number[]): Observable<PriceEstimator> {
    return this.create({ ids }, false, {
      cacheExpirationTime: Time.TEN_MINUTES,
      forcedKey: `price-estimator-${ids.join('-')}`,
    }) as Observable<PriceEstimator>;
  }
}
